import React from 'react';
import LegalDraftPage from '../components/LegalDraftPage';
import { showCookieBanner } from '../components/CookieBanner';
import { cookieDraft } from '../content/legalDrafts';

const CookiePolicyPage = () => <LegalDraftPage draft={cookieDraft} onCookiePreferences={showCookieBanner} />;

export default CookiePolicyPage;
